const route = {
	name: 'sync-odoo',
	path: 'sync-odoo',
	meta: {
		title: 'Sincronización Odoo',
	},
	component: () => import('@/pages/syncs/sync-odoo'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/sync-odoo.js